export default __webpack_public_path__ + "static/media/ic-email.1ac0039e.svg";